import React from "react"
import { graphql, navigate, Link } from "gatsby"
import SEO from "../components/seo"
import Modal from "react-modal"
import Chunk from "lodash.chunk"
import camelcase from "lodash.camelcase"
import Img from "gatsby-image"

import Slider from "react-slick"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import Layout from "../components/layout"
import styles from "../styles/pricing.module.scss"

import Toggle from "react-toggle"
import "../styles/react-toggle/react-toggle.css"

import checkmark from "../images/checkmark-icon.svg"
import none from "../images/none-icon.svg"

export const query = graphql`
  query PRICING_DATA {
    wpgraphql {
      corePageBy(corePageId: 7140) {
        id
        title
        seo {
          metaDesc
          title
          twitterTitle
          twitterDescription
          opengraphTitle
          opengraphDescription
        }
        acfPricing {
          pricingPageHeader {
            leftToggleLabel
            rightToggleLabel
            saveMessage
            subText
            title
          }
          pricingCardContainer {
            badge
            buttonEyebrow
            priceMonthly
            priceAnnual
            fieldGroupName
            planSummary
            planType
            planCode
            signUpButton
          }
          pricingListHeader
          pricingListTable {
            fieldGroupName
            listGroupTitle
            listRow {
              enterpriseColumn
              essentialsColumn
              feature
              fieldGroupName
              professionalColumn
              standardColumn
            }
          }
          countriesModal {
            country
            flag {
              altText
              sourceUrl
              imageFile {
                childImageSharp {
                  fixed(width: 26, webpQuality: 90) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                  }
                }
              }
            }
          }

          featuresCta {
            class
            icon {
              altText
              sourceUrl
              slug
            }
            subtext
            title
            buttonText
          }

          testimonials {
            image {
              sourceUrl
              altText
              imageFile {
                childImageSharp {
                  fixed(width: 64, webpQuality: 100) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                  }
                }
              }
            }
            quote
            name
            company
          }
        }
      }
    }
  }
`

const MobileFeaturesList = props => {
  return (
    <div className={styles.mobileFeaturesListContainer}>
      {props.pricingListGroup.map((group, index) => (
        <div key={index}>
          <div className={styles.mobileFeaturesGroupName}>
            {group.listGroupTitle.toUpperCase()}
          </div>
          {group.listRow.map((row, index) => (
            <div key={index} className={styles.mobileFeaturesRow}>
              <div
                className={styles.mobileFeature}
                dangerouslySetInnerHTML={{ __html: row.feature }}
              ></div>
              <div className={styles.featureField}>
                {props.planType === "Essentials" &&
                  renderColumnField(row.essentialsColumn)}
                {props.planType === "Standard" &&
                  renderColumnField(row.standardColumn)}
                {props.planType === "Professional" &&
                  renderColumnField(row.professionalColumn)}
                {props.planType === "Enterprise" &&
                  renderColumnField(row.enterpriseColumn)}
                {props.planType === "Pay As You Go" &&
                  renderColumnField(row.enterpriseColumn)}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

class PricingCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      viewFeatures: false,
    }

    this.handleViewFeaturesClick = this.handleViewFeaturesClick.bind(this)
  }

  handleViewFeaturesClick() {
    this.setState({
      viewFeatures: !this.state.viewFeatures,
    })
  }

  render() {
    return (
      <div
        className={`${styles.essentialsCard} ${styles.pricingCard} ${
          (this.props.planType === "Enterprise" || this.props.planType === "Pay As You Go") ? styles.enterprisePricing : null
        }`}
      >
        <div className={styles.participantBadge}>{this.props.badge}</div>
        <div className={styles.planTypeContainer}>
          <div className={styles.planType}>{this.props.planType}</div>
          <div className={styles.planPriceContainer}>
            <h2>
              {this.props.isAnnual
                ? this.props.priceAnnual
                : this.props.priceMonthly}
            </h2>
            <span>
              <div>/mo</div>
              <div>/user</div>
            </span>
          </div>
        </div>
        <p
          className={styles.planSummary}
          dangerouslySetInnerHTML={{ __html: this.props.planSummary }}
        />
        <div
          className={styles.buttonEyebrow}
          style={{
            visibility: this.props.buttonEyebrow ? "visible" : "hidden",
          }}
        >
          {!this.props.buttonEyebrow && "eyebrow"}
          {this.props.buttonEyebrow && this.props.buttonEyebrow}
        </div>
        <button
          onClick={() =>             
              this.props.goToSignup(this.props.planType, this.props.planCode, this.props.isAnnual)            
          }
          className={`${styles.planButton} ${!this.props.isAnnual &&
            (this.props.planType !== "Enterprise" && this.props.planType !== "Pay As You Go" ) &&
            styles.monthly}`}
          dangerouslySetInnerHTML={{ __html: this.props.signUpButton }}
        ></button>

        <button
          onClick={this.handleViewFeaturesClick}
          className={styles.expandButton}
        >
          {`View Features ${this.state.viewFeatures ? "-" : "+"}`}
        </button>
        {this.state.viewFeatures && (
          <MobileFeaturesList
            pricingListGroup={this.props.pricingListGroup}
            planType={this.props.planType}
          />
        )}
      </div>
    )
  }
}

const ComparePricingCTA = ({ cards, isAnnual, goToSignup }) => {
  return (
    <>
      <div className={styles.lOverviewBlock}></div>
      {cards.map((card, index) => (
        <div
          key={index}
          className={`${styles.lOverviewBlock} ${(card.planType === "Enterprise" || card.planType === "Pay As You Go" )&& styles.enterprise}`}
        >
          <div className={styles.lPlanType}>{card.planType}</div>
          {(card.planType !== "Enterprise" && card.planType !== "Pay As You Go" )? (
            <div className={styles.lPriceContainer}>
              <div>{isAnnual ? card.priceAnnual : card.priceMonthly}</div>
              <span>/mo</span>
            </div>
          ) : (
            <div className={styles.lPriceContainer}>
              <div>{card.priceAnnual}</div>
            </div>
          )}
          <div className={styles.perUser}>PER USER</div>
          <div className={styles.signUpButtonContainer}>
            <button
              onClick={() => goToSignup(card.planType, card.planCode, isAnnual)}
              className={`${styles.signUpButton} ${!isAnnual &&
                (card.planType !== "Enterprise" && card.planType !== "Pay As You Go") &&
                styles.monthly}`}
            >
              {card.buttonEyebrow && card.buttonEyebrow.toUpperCase()}
              {!card.buttonEyebrow && card.signUpButton.toUpperCase()}
            </button>
          </div>
        </div>
      ))}
    </>
  )
}

const renderColumnField = columnField => {
  if (columnField === "check") {
    return <img src={checkmark} alt="checkmark icon" />
  }

  if (columnField === "none") {
    return <img src={none} alt="none icon" />
  }

  if (columnField.includes("countries")) {
    return <Link to="/international-conference-rates">{columnField}</Link>
  }

  return columnField
}

class PricingListGroup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // isAnnual: true,
      // modelOpen: false,
    }
  }

  render() {
    return (
      <>
        <div className={styles.lListRowHeader}>
          <div className={styles.listBorder}>
            <div className={styles.titleWrapper}>
              {this.props.listGroupTitle.toUpperCase()}
            </div>
          </div>
          {/* empty divs for space and separators */}
          <div className={styles.listBorder}></div>
          <div className={styles.listBorder}></div>
          <div className={styles.listBorder}></div>
          <div className={styles.listBorder}></div>
        </div>

        {this.props.listRow.map((row, index) => (
          <div key={index} className={styles.lListRow}>
            <div className={styles.feature}>
              <div
                className={styles.featureWrapper}
                dangerouslySetInnerHTML={{ __html: row.feature }}
                onClick={
                  row.feature.includes("modal")
                    ? this.props.modalFunction
                    : undefined
                }
              />
            </div>
            <div className={styles.centerBlock}>
              {renderColumnField(row.essentialsColumn)}
            </div>
            <div className={styles.centerBlock}>
              {renderColumnField(row.standardColumn)}
            </div>
            <div className={styles.centerBlock}>
              {renderColumnField(row.professionalColumn)}
            </div>
            <div className={styles.centerBlock}>
              {renderColumnField(row.enterpriseColumn)}
            </div>
          </div>
        ))}
      </>
    )
  }
}

const ModalContent = props => (
  <div className={styles.modalContainer}>
    <button onClick={props.close}>Close</button>
    <div className={styles.modalHeader}>
      <div className={styles.modalTitlte}>
        52 local country numbers included with unlimited audio and web
      </div>
    </div>
    <div className={styles.countriesGrid}>
      {props.data.map((row, index) => (
        <div key={index} className={styles.countriesRow}>
          {row.map(country => (
            <div key={country.country}>
              <div className={styles.flagContainer}>
                <Img
                  fixed={country.flag.imageFile.childImageSharp.fixed}
                  alt={country.flag.altText}
                />
              </div>
              <span>{country.country}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
)

class Pricing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAnnual: true,
      modalOpen: false,
    }

    this.handleToggleChange = this.handleToggleChange.bind(this)
    this.handleModalClick = this.handleModalClick.bind(this)
    this.goToSignup = this.goToSignup.bind(this)
  }

  handleToggleChange() {
    this.setState({
      isAnnual: !this.state.isAnnual,
    })
  }

  handleModalClick() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  goToSignup(planType, planCode, isAnnual) {
    // if enterprise card
    if (planCode === 0) {
      navigate("/demo")
      return
    }

    if( planType === "Pay As You Go")   {
      navigate(`/signup?pid=${planCode}`)
      return;
    }

    // essentials, standard, professional cards
    if (isAnnual) {
      navigate(`/signup?pid=${planCode}&p=ANNUALTRIAL&annual=true`)
    } else {
      navigate(`/signup?pid=${planCode}&p=FREE14DAY`)
    }
  }

  render() {
    const seo = this.props.data.wpgraphql.corePageBy.seo
    const pricingQuery = this.props.data.wpgraphql.corePageBy.acfPricing
    const pricingPageHeader = pricingQuery.pricingPageHeader
    const pricingCards = pricingQuery.pricingCardContainer
    const pricingListHeader = pricingQuery.pricingListHeader
    const pricingListGroup = pricingQuery.pricingListTable
    const countriesList = pricingQuery.countriesModal
    const featuresArray = pricingQuery.featuresCta
    const testimonialsArray = pricingQuery.testimonials

    const customModalStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        boxShadow: "0px 7px 80px rgba(0, 0, 0, 0.1)",
        border: "none",
      },
      overlay: {
        backgroundColor: "rgba(0, 0, 0, .4)",
        zIndex: 9999,
      },
    }

    const testimonialSettings = {
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: "reactz-dots",
    }

    return (
      <Layout>
        <SEO {...seo} />
        <Modal
          isOpen={this.state.modalOpen}
          style={customModalStyles}
          onRequestClose={this.handleModalClick}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <ModalContent
            close={this.handleModalClick}
            data={Chunk(countriesList, 4)}
          />
        </Modal>
        <section className={styles.pricingHeader}>
          <h1>{pricingPageHeader.title}</h1>
          <p>{pricingPageHeader.subText}</p>

          <div id="anchor-link" className={styles.priceSwitchContainer}>
            <div className={styles.save}>{pricingPageHeader.saveMessage}</div>
            <div className={styles.toggleContainer}>
              <label htmlFor="pricing-toggle">
                {pricingPageHeader.leftToggleLabel}
              </label>
              <Toggle
                id="pricing-toggle"
                defaultChecked={this.state.isAnnual}
                aria-labelledby="pricing-toggle"
                icons={false}
                onChange={this.handleToggleChange}
              />
              <label htmlFor="pricing-toggle">
                {pricingPageHeader.rightToggleLabel}
              </label>
            </div>
          </div>
        </section>

        <section>
          <div className={styles.pricingGridContainer}>
            {pricingCards.map(card => (
              <PricingCard
                key={card.planType}
                isAnnual={this.state.isAnnual}
                pricingListGroup={pricingListGroup}
                goToSignup={this.goToSignup}
                {...card}
              />
            ))}
          </div>
        </section>

        <section className={styles.pricingList}>
          <div className={styles.compareHeader}>
            <h2>Compare Plans</h2>
          </div>
          <div className={styles.compareList}>
            <div className={styles.lOverviewRow}>
              <ComparePricingCTA
                cards={pricingCards}
                goToSignup={this.goToSignup}
                isAnnual={this.state.isAnnual}
              />
            </div>

            {pricingListGroup.map((group, index) => (
              <PricingListGroup
                key={index}
                modalFunction={this.handleModalClick}
                {...group}
              />
            ))}
          </div>
          <div className={`${styles.lOverviewRow} ${styles.bottomCta}`}>
            <ComparePricingCTA
              cards={pricingCards}
              goToSignup={this.goToSignup}
              isAnnual={this.state.isAnnual}
            />
          </div>
        </section>
        <div className={styles.featureSectionContainer}>
          {featuresArray.map((feature, index) => (
            <div key={index} className={styles.featureContainer}>
              <div className={styles.feature}>
                <div className={styles.icon}>
                  <div>
                    <img
                      src={`/images/acf-icons/${feature.icon.slug}.svg`}
                      alt={feature.icon.altText}
                    />
                  </div>
                </div>
                <div>
                  <h4>{feature.title}</h4>
                  <p>{feature.subtext}</p>
                  <a href="#anchor-link">{feature.buttonText}</a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <Slider className={styles.testimonialSection} {...testimonialSettings}>
          {testimonialsArray.map((testimonial, index) => (
            <div key={index} className={styles.box}>
              <div className={styles.testimonialContainer}>
                {testimonial.image && (
                  <div className={styles.profile}>
                    <div className={styles.imageContainer}>
                      {/* <img
                        src={testimonial.image.sourceUrl}
                        alt="customer profile"
                      /> */}
                      <Img
                        fixed={
                          testimonial.image.imageFile.childImageSharp.fixed
                        }
                        alt="customer profile"
                      />
                    </div>
                  </div>
                )}
                <div className={styles.quote}>
                  &#8220;{testimonial.quote}&#8221;
                </div>
                <div className={styles.quoteDetails}>
                  {testimonial.name} <span>/</span> {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Layout>
    )
  }
}

export default Pricing
